import {
    serverBus
} from '@/main'
import SessionManager from '@/Manager/Session.manager';
import Global from '@/scripts/Global';
import KeyboardManager from '@/Manager/keyboard.manager';
import {
    CPUtils
} from '@/scripts/Utils';
import TextareaManager from '@/Manager/Textarea.manager';
import VueSignals from '@/scripts/VueSignals';
import DOMManager from '@/Manager/DOM.manager';

let mentionMatch = ''
export default {
    name: 'MentionUsers',
    data() {
        return {
            showAvailableUsers: false,
            activeChannelUsers: CPUtils.RemoveLoggedInUser(SessionManager.getActiveChannelUsers()),
            mentionMatch: '',
            mentionFilterMode: false,
            spanMentionId: '',
            windowWidth: window.innerWidth,
            filterMode: false,
            spanMention: null
        }
    },

    mounted() {
        serverBus.$on("mention_to_delete", (mention_id) => {
            if (document.querySelector(".mention_suggest") != null) {
                document.querySelector(".mention_suggest").addEventListener('click', function(e) {
                    this.spanMentionId = e.target.dataset.id
                    Global.globalValue(VueSignals.SHOW_MENTION_USERS, true)
                })
            }
        })

        serverBus.$on("mention_delete_open_list", (params) => {
            this.spanMentionId = params.id;
            Global.globalValue(VueSignals.SHOW_MENTION_USERS, true);
            this.triggerMentionSearch(params.search);
        })

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (channel) => {
            this.activeChannelUsers = SessionManager.getActiveChannelUsers()
            this.activeChannelUsers = CPUtils.RemoveLoggedInUser(this.activeChannelUsers)
            Global.globalValue(VueSignals.HIDE_MENTION_USERS, true)
        })

        serverBus.$on(VueSignals.EVENT_USER_CHANGED, (user_id) => {
            this.activeChannelUsers = CPUtils.RemoveLoggedInUser(this.activeChannelUsers)
        })

        serverBus.$on(VueSignals.HIDE_KEYBOARD_GENERATED_LIST, (success) => {
            this.showAvailableUsers = false
        })

        serverBus.$on(VueSignals.CREATE_MENTION_USER, (success) => {
            this.spanMentionId = Global.SaltID(5)
            Global.globalValue(VueSignals.SHOW_MENTION_USERS, true)
        })


        serverBus.$on("windowResize", (success) => {
            this.windowWidth = window.innerWidth
        })

        serverBus.$on(VueSignals.SHOW_MENTION_USERS, (success) => {
            // if(this.windowWidth > 680){
            KeyboardManager.setListOpen(true)
            KeyboardManager.setMentionInstruc()
            this.showAvailableUsers = true
            this.activeChannelUsers = SessionManager.getActiveChannelUsers()
            this.activeChannelUsers = CPUtils.RemoveLoggedInUser(this.activeChannelUsers)
            this.mentionFilterMode = true
            this.filterMode = true
            // }
        });

        serverBus.$on(VueSignals.HIDE_MENTION_USERS, (success) => {
            this.showAvailableUsers = false
            this.mentionFilterMode = false
            this.filterMode = false
            this.mentionMatch = ''
            this.spanMentionId = ''
            this.activeChannelUsers = CPUtils.RemoveLoggedInUser(SessionManager.getActiveChannelUsers())
            // setTimeout(function(){KeyboardManager.setListOpen(false)}, 100)
        })

        serverBus.$on(VueSignals.KEYBOARD_CLOSE_MESSAGE_LIST, (success) => {
            if (this.showAvailableUsers) {
                Global.globalValue(VueSignals.HIDE_MENTION_USERS, true)
            }
        })

        serverBus.$on(VueSignals.KEYBOARD_FILTERED_MENTION_USERS, (users) => {
            if (users.length > 0) {
                Global.globalValue(VueSignals.SHOW_MENTION_USERS, true)
                this.activeChannelUsers = users
            } else {
                Global.globalValue(VueSignals.HIDE_MENTION_USERS, true)
            }
        })


        serverBus.$on(VueSignals.KEYBOARD_MENTION_USER_TAG_FEED, (e) => {
            if (this.mentionFilterMode && this.showAvailableUsers) {
                if (this.filterMode) {
                    if (e.key == "Backspace") { // refill and show if it has a value
                        this.mentionMatch = this.mentionMatch.slice(0, this.mentionMatch.length - 1)
                    } else {
                        if (e.key.length == 1) {
                            this.mentionMatch += e.key
                        }
                    }

                    this.triggerMentionSearch();

                    if (e.code == "Enter" || e.code == "Space" && document.querySelector('.mention-item.active') != null) { // select with space
                        let mention_id = document.querySelector('.mention-item.active').id
                        let active_mention_item = document.querySelector('.mention-item.active').innerText.trim()
                        let mention_type = document.querySelector('.mention-item.active').dataset.type

                        Global.globalValue(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM, {
                            "mention_item": active_mention_item,
                            "mention_id": mention_id,
                            "mention_type": mention_type
                        })
                        Global.globalValue(VueSignals.KEYBOARD_CHOOSE_MENTION_ITEM, document.querySelector('.mention-item.active').id)
                        Global.globalValue(VueSignals.HIDE_MENTION_USERS, true)
                    }
                }

            }
        })

        serverBus.$on(VueSignals.KEYBOARD_NAVIGATE_MENTION_ITEM, (data) => {
            if (data.mention_type == 'user') {
                this.NaveMentionUser(data.mention_item, data.mention_id)
            }
        })

        serverBus.$on(VueSignals.KEYBOARD_CHOOSE_MENTION_ITEM, (user_id) => {
            if (user_id != 'everyone') {
                let user = this.activeChannelUsers.find(currUser => currUser.user_id == user_id)
                if (typeof user != 'undefined' &&
                    user != null) {
                    this.mentionUser(user_id)
                }
            } else {
                this.mentionUser('eveyone')
            }
        })

        serverBus.$on(VueSignals.DRAG_DROP_USER_MENTION, (user) => {
            this.spanMentionId = Global.SaltID(5);
            // this.mentionUser(user_id);
            this.NaveMentionUser(user.user_name, user.user_id);
            Global.globalValue(VueSignals.REMOVE_TEXTAREA_PLACEHOLDER, true);
        })
    },
    methods: {
        allActiveChannelUsers() {
            return CPUtils.RemoveLoggedInUser(SessionManager.getActiveChannelUsers())
        },
        NaveMentionUser(user_name, user_id) {
            let span = document.createElement("span")
            span.classList = 'mention_slag'
            span.dataset.id = this.spanMentionId
            span.dataset.mention = user_id
            span.dataset.type = "user"
            span.innerText = "@" + user_name
            let span_position = TextareaManager.getChildPositionByDataID(this.spanMentionId)

            // If the mention is clicked save the span to put the cursor in the right position
            this.spanMention = span;
            // important to detect first element even though the input area is empty
            if (span_position == null || span_position.node.data == '@') {
                if (span.dataset.id.length > 0) {
                    TextareaManager.AddToCursor(span);
                }
            } else {
                let element = TextareaManager.getChildByDataID(this.spanMentionId)
                if (typeof element != 'undefined' && typeof element.textContent != 'undefined') {
                    element.textContent = "@" + user_name
                    // Sometime an already created span won't change the data info that's why this
                    element.dataset.id = this.spanMentionId
                    element.dataset.mention = user_id
                    element.dataset.type = "user"

                    if (element.classList.contains('mention_suggest')) {
                        element.classList.remove('mention_suggest')
                        element.classList.add('mention_slag')
                        TextareaManager.MoveCursorAfterAdd(element);

                        // let range = document.createRange()
                        // let sel = window.getSelection()
                        // let text = document.createTextNode("\u00A0")
                        // // DOMManager.insertAfter(text, span_position.node)
                        // range.setStartAfter(text)
                        // range.collapse(true)
                        // sel.removeAllRanges()
                        // sel.addRange(range)
                    }
                }
                //@refactor NO NEEDED
                else if (typeof element != 'undefined' && element.classList.contains('mention_suggest')) {
                    element.classList.remove('mention_suggest')
                    element.classList.add('mention_slag')
                    let range = document.createRange()
                    let sel = window.getSelection()
                    let text = document.createTextNode("\u00A0")
                    // DOMManager.insertAfter(text, span_position.node)
                    range.setStartAfter(text)
                    range.collapse(true)
                    sel.removeAllRanges()
                    sel.addRange(range)
                } else {
                    TextareaManager.AddToCursor(span)
                }
            }

            // For mobile hovering is one tap so should be closed the mention list
            if (this.windowWidth <= 680){
                Global.globalValue(VueSignals.HIDE_MENTION_USERS, true);
            }
        },
        mentionUser(mentiond_user_cpid) {
            Global.globalValue(VueSignals.HIDE_MENTION_USERS, true)
            Global.globalValue('mentionUser', {
                'mentiond_user_cpid': mentiond_user_cpid
            })
        },
        clickHandler() {
            KeyboardManager.setListOpen(false);
            // Global.globalValue(VueSignals.TOOGLE_TEXT_CARET, true)

            // Put the cursor in the right position after clicking a mention
            TextareaManager.MoveCursorAfterAdd(this.spanMention);
            this.spanMention = null;
        },
        triggerMentionSearch(search) {
            if (search) {
                this.mentionMatch = search;
            }
            this.mentionMatch = this.mentionMatch.replace(/@/g, '').toLowerCase().trim();
            let OriginalUsers = this.allActiveChannelUsers();
            let FilterdOriginalUsers = [];
            FilterdOriginalUsers = OriginalUsers.filter(currUser => {
                return currUser.username.toLowerCase().indexOf(this.mentionMatch.toLowerCase()) > -1
            })
            if (this.mentionMatch.trim().length == 0) {
                Global.globalValue(VueSignals.KEYBOARD_FILTERED_MENTION_USERS, OriginalUsers);
            } else {
                Global.globalValue(VueSignals.KEYBOARD_FILTERED_MENTION_USERS, FilterdOriginalUsers);
            }
        }
    }

}
